import MetaFieldMultiSelect from "./MetaFieldComponents/MetaFieldMultiSelect";
import MetaFieldNumber from "./MetaFieldComponents/MetaFieldNumber";
import MetaFieldSingleLineText from "./MetaFieldComponents/MetaFieldSingleLineText";
import MetaFieldDate from "./MetaFieldComponents/MetaFieldDate";
import MetaFieldSingleSelect from "./MetaFieldComponents/MetaFieldSingleSelect";

const MetaFieldComponentMapping = {
  MULTI_SELECT: MetaFieldMultiSelect,
  NUMBER: MetaFieldNumber,
  TEXT: MetaFieldSingleLineText,
  DATE: MetaFieldDate,
  SINGLE_SELECT: MetaFieldSingleSelect,
};

export { MetaFieldComponentMapping as default };
